<template>
    <div v-if="filter" class="lm-border pa-3">
        <v-row class="no-frame">
            <v-col class="no-frame v-flex">
                <v-checkbox
                    label   = "aktiv"
                    v-model = "filter.active"
                    class   = "mt-0"
                    :ripple = "false"
                    @change = "onChange"
                    hide-details
                />
            </v-col>
            <v-col class="no-frame v-flex">
                <v-checkbox
                    label   = "inaktiv"
                    v-model = "filter.inactive"
                    class   = "mt-0"
                    :ripple = "false"
                    @change = "onChange"
                    hide-details
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    name: "CContractZusCardFilter",

    components: {
    },

    props: {
        value: {

        }
    },

    data: () => ({
        filter  : {
            active     : true,
            inactive   : false,
        }
    }),

    methods: {
        onChange () {
            const filter = this.createFilter();
            console.log("first filter", filter)
            this.$emit("input", filter);
        },

        createFilter () {
            const types = [];

            types.push ("ZUS");

            return {
                types   : types,
                active  : this.filter.active,
                inactive: this.filter.inactive,
            }
        },
    }
}
</script>

<style scoped>

.contract-label {
    width: 100px;
}

</style>